import { Redirect, Route } from "react-router-dom";

import { localStorageToken , authStorage} from "../../utils/variables";

const GuestRoute = ({ children, ...rest }) => {
  // States

  const token = authStorage.getItem(localStorageToken);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        !token ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/dashboard",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default GuestRoute;
